import type { RuleSectionView } from '@tabel/shared/schemas/rules';
import { LABEL, say } from './texts';

/** Якорь блока «Как система считает день». */
export const HOW_ID = 'how';

/** Якорь раздела страницы: `#section-<id>`. */
export const sectionAnchor = (id: string) => `section-${id}`;

/**
 * «Как система считает день» (004, FR-002): восемь строк «n · название — предложение» в порядке расчёта дня, каждая
 * ведёт к своему разделу. На телефоне строка — цель нажатия не ниже 40 px.
 */
export function HowDayIsCounted({ sections }: { sections: readonly RuleSectionView[] }) {
  return (
    <section
      id={HOW_ID}
      aria-labelledby="how-title"
      className="scroll-mt-4 rounded-card border border-line bg-surface px-5 py-4 max-sm:px-4"
    >
      <h2 id="how-title" className="text-[15px] font-semibold text-ink">
        {LABEL.howTitle}
      </h2>
      <ol className="mt-2 space-y-0.5 text-[13.5px]">
        {[...sections]
          .sort((a, b) => a.n - b.n)
          .map((s) => (
            <li key={s.id}>
              <a
                href={`#${sectionAnchor(s.id)}`}
                className="inline-block py-0.5 text-accent hover:underline max-sm:flex max-sm:min-h-10 max-sm:items-center"
              >
                {say.section(s.n, s.title, s.sentence)}
              </a>
            </li>
          ))}
      </ol>
    </section>
  );
}
